
const Table = () => import('@/../../coreui/components/ServerTable')

export default function buildMenu (allowed) {
  var routes = []
  if (allowed == null || allowed.includes('Testing'))  {
    routes =  [
      {
        path: '/TesInventory',
        name: 'TesInventory',
        component: Table,
        props: {
          schema: 'sch_tes_inventory', 
          table: 'tes_inventory'
        } 
      },
      // {
      //   path: '/TesInventory',
      //   name: 'TesInventory',
      //   component: Table,
      //   props: {
      //     schema: 'sch_test_inventory', 
      //     table: 'tes_inventory'
      //   } 
      // },
    ] 
  } 
  return routes
}
